module.exports = "<div *ngIf=\"message\" [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">{{message.text}}<a href=\"#\" style=\"float:right;\" (click)=\"clearMessage()\">[X] </a></div>"


//////////////////
// WEBPACK FOOTER
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/directives/alert.component.html
// module id = ../../../../../src/app/directives/alert.component.html
// module chunks = main